import { motion } from "framer-motion";
import { Youtube, Linkedin, Instagram, Facebook } from "lucide-react";
import { specMove } from "./glass";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" />
  </svg>
);

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
  </svg>
);

const ICONS = [
  { id: "youtube", label: "YouTube", Icon: Youtube, pos: "top-[8%] left-[6%]", dur: 6.2, delay: 0 },
  { id: "linkedin", label: "LinkedIn", Icon: Linkedin, pos: "top-[52%] left-[2%]", dur: 7.4, delay: 0.8 },
  { id: "x", label: "X", Icon: XIcon, pos: "top-[12%] right-[7%]", dur: 5.6, delay: 0.4 },
  { id: "instagram", label: "Instagram", Icon: Instagram, pos: "top-[56%] right-[3%]", dur: 6.8, delay: 1.2 },
  { id: "tiktok", label: "TikTok", Icon: TikTokIcon, pos: "top-[86%] left-[18%]", dur: 7.8, delay: 0.2 },
  { id: "facebook", label: "Facebook", Icon: Facebook, pos: "top-[82%] right-[20%]", dur: 6.0, delay: 1.6 },
];

export default function FloatingSocials() {
  return (
    <div
      className="absolute inset-0 pointer-events-none hidden lg:block"
      data-testid="floating-social-icons-container"
      aria-hidden="true"
    >
      {ICONS.map(({ id, label, Icon, pos, dur, delay }, i) => (
        <motion.div
          key={id}
          className={`absolute ${pos} pointer-events-auto`}
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ delay: 1 + i * 0.12, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.div
            drag
            dragElastic={0.35}
            dragTransition={{ bounceStiffness: 200, bounceDamping: 14 }}
            whileHover={{ scale: 1.12, y: -4 }}
            whileTap={{ scale: 0.92 }}
            animate={{ y: [0, -12, 0] }}
            transition={{ y: { duration: dur, repeat: Infinity, ease: "easeInOut", delay } }}
            onMouseMove={specMove}
            className="glass glass-sheen glass-spec group flex h-14 w-14 cursor-grab items-center justify-center rounded-[22px] opacity-60 transition-opacity duration-300 hover:opacity-100 active:cursor-grabbing will-change-transform"
            data-testid={`social-icon-${id}`}
            title={label}
          >
            <Icon className="h-5 w-5 text-[#6e6e73] transition-colors duration-300 group-hover:text-[#1d1d1f]" />
          </motion.div>
        </motion.div>
      ))}
    </div>
  );
}
